import userService from '@/services/UserService';

const employees = {
  state: {
    employees: [],
    employee: {},
  },
  getters: {
    employees(state) {
      return state.employees;
    },
    employee(state) {
      return state.employee;
    },
  },
  mutations: {
    SET_EMPLOYEES_LIST(state, payload) {
      state.employees = payload;
    },
    SET_EMPLOYEE(state, payload) {
      state.employee = payload;
    },
  },
  actions: {
    async getEmployees({ commit }) {
      const response = await userService.getUsers();
      commit('SET_EMPLOYEES_LIST', response.data);
    },
    async setEmployee({ commit }, payload) {
      commit('SET_EMPLOYEE', payload);
    },
  },
};

export default employees;



// WEBPACK FOOTER //
// ./src/vuex/setting/employees.js